import { render, staticRenderFns } from "./DialogHeader.vue?vue&type=template&id=5aa58964"
import script from "./DialogHeader.vue?vue&type=script&lang=js"
export * from "./DialogHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports